<template lang="pug">
.el-container(id="MediumEditor-container")
  .el-card.el-card-margin-4.el-card-full-width.el-card-full-height-with-scroll(v-if="!medium && !loading", style="text-align:center")
    h4 {{ $t('Pick a medium in left panel.')}}
  .el-card.el-card-margin-4.el-card-full-width.el-card-full-height-with-scroll(v-if="medium", @click.self='deselectPlayitems($event)')
    el-header
      .header-title-underlined
        .thumbnail(:style="getMediumThumbnailPath(medium) === null ? '' : {'background-image': 'url(' + getMediumThumbnailPath(medium) + ')'}")
        .medium-header-text
          .text-line.first-line
            MediumIcon(:medium="medium")
            span.selectable(:title='getMediumName(mediumInStore)') &nbsp;&nbsp; {{ getMediumName(mediumInStore) }}
          .text-line.second-line(v-if='medium.type.indexOf("Video") > -1')
            span {{ msToDuration(medium.File.originalDurationMs) }}
          .text-line.second-line(v-if='medium.type.startsWith("PlayList") && playListData')
            span {{ msToDuration(playListData.playListDurationMs) }}&nbsp;-&nbsp;
            span {{ playListData.itemsLength }}
            span &nbsp;{{$t('elements')}}
        el-button-group.media-editor-menu
          el-dropdown(id="MediumEditor-headerDropdown" trigger="click", @command="loadMediumFromHistory")
            el-button.menu-button.separator(
              id="MediumEditor-headerDropdownButton",
              type="text",
              :title="$t('Previously edited media')"
            )
              font-awesome-icon(icon="undo")
            el-dropdown-menu(id="MediumEditor-headerDropdownMedia" slot='dropdown')
              el-dropdown-item(:command="medium", v-for="medium in this.$store.state.Medium.media_edit_history.filter(m => m && m.id)", :key='medium.id', :id="'MediumEditor-headerDropdownMediaMedium' + medium.id" )
                span
                  MediumIcon(:medium="medium")
                  span &nbsp; &nbsp; {{ getMediumName(medium) }}
          el-button.menu-button(
            v-if='medium.type.startsWith("PlayList")',
            id="MediumEditor-headerOptionsButton",
            @click='showMediumTreeView()',
            type="text",
            :title="$t('Tree view')",
          )
            font-awesome-icon(icon='folder-tree')
          el-button.menu-button(
            id="MediumEditor-editMediumButton",
            @click='showMediumBasicEditor()',
            type="text",
            :title="$t('Edit medium')"
          )
            font-awesome-icon(icon="edit")
      hr.header
    MediumInPlaylists(
      id="MediumEditor-mediumInPlaylists",
      v-if="componentVisible === 'MediumInPlaylists'",
      :medium = "medium",
      :selectedPlayitemId = "selectedPlayitemId",
      @loadEditMediumInMediaEditor="loadMediumFromHistory",
      @loadPathInLibrary="loadPathInLibrary"
    )
    PlayListEditor(
      v-if='componentVisible === "PlayListEditor" && medium.type.startsWith("PlayList")',
      id="MediumEditor-playlistsEditor",
      :playList = "medium",
      ref='PlayListEditor',
      :simpleMode = 'true',
      @loadEditMediumInMediaEditor="loadEditMediumInMediaEditor",
      @loadMediumUsageInMediaEditor="loadMediumUsageInMediaEditor",
      @reloadLeftComponent="reloadLeftComponent",
      @playlistDataUpdate="setPlaylistData"
    )
    LayoutEditorSmall(
      v-if='componentVisible === "LayoutEditorSmall" && medium.type.startsWith("PlayList")',
      id="MediumEditor-layoutEditorSmall",
      :layoutMedium='medium',
      ref='LayoutEditorSmall',
      @loadEditMediumInMediaEditor='loadEditMediumInMediaEditor',
      @loadMediumUsageInMediaEditor="loadMediumUsageInMediaEditor",
      @refreshLayout='refreshPlayListLayout()',
      @playlistDataUpdate="setPlaylistData"
    )
    el-dialog(:close-on-click-modal="false",
      :visible.sync="mediumBasicEditorVisible",
      @close='closeMediumBasicEditor()',
      append-to-body, width="100%"
    )
      MediumBasicEditor(v-if='medium', :mediumId='medium.id')
    el-dialog(:close-on-click-modal="false",
      :visible.sync="playListTreeVisible",
      @close='closeMediumTreeView()',
      append-to-body, width="100%"
    )
      .header-row-playlist-tree
        h4
          MediumIcon(:medium="medium")
          span &nbsp; {{ getMediumName(mediumInStore) }} &nbsp;
        .switch-view-buttons
          el-button-group
            el-button.tree-view-button(
              v-for='(param, key) of treeViewParams',
              size='mini',
              :type='treeViewParams[key].value ? "success" : "primary"',
              :title='treeViewParams[key].value ? treeViewParams[key].titleDeactivate : treeViewParams[key].titleActivate',
              v-model='treeViewParams[key].value',
              :key='key',
              @click='toggleTreeViewParam(key)'
            )
              font-awesome-icon(:icon="param.icon")
        .date-picker
          el-date-picker(v-if='playListTreeVisible', v-model='timestampForTree', type='datetime', size='mini', :placeholder="$t('Select date and time')")
      hr.header
      PlayListTree(v-if='playListTreeVisible', :playListTree='playListTree', :timestampForTree='timestampForTree', :treeViewParams='treeViewParams', @reloadPlayListTree='showMediumTreeView()')
</template>
<script>
import Vue from 'vue'
import MediumInPlaylists from './MediumInPlaylists'
import MediumBasicEditor from './MediumBasicEditor'
import PlayListTree from './PlayListTree'
import PlayListEditor from './PlayListEditor'
import LayoutEditorSmall from './LayoutEditorSmall'
import ListItemMixin from './ListItem.mixin'
import mediaUtils from '../Common/mediaUtils.mixin'
import textUtils from '../Common/textUtils.mixin'
import { required, minLength } from 'vuelidate/lib/validators'
import MediumIcon from './../Common/MediumIcon'

export default {
  mixins: [ListItemMixin, mediaUtils, textUtils],
  components: {
    PlayListEditor,
    LayoutEditorSmall,
    MediumInPlaylists,
    MediumIcon,
    MediumBasicEditor,
    PlayListTree
  },
  props: {
    mediumId: {
      required: true
    },
    PlayItemId: {
      required: false
    }
  },
  async created () {
    this.newMediumId = this.mediumId !== 0 ? this.mediumId : parseInt(this.$route.params.mediumEditor.split(',')[1])
  },
  data () {
    return {
      errors: {},
      medium: undefined,
      mediumInStore: undefined,
      newMediumId: undefined,
      selectedPlayitemId: 0,
      replaceLastPathItem: false,
      componentVisible: undefined,
      componentVisibleRequested: undefined,
      mediumBasicEditorVisible: false,
      playListTreeVisible: false,
      mediumFromSelectBox: undefined,
      loading: false,
      playListData: undefined,
      playListTree: {
        PlayItems: [],
        type: '',
        mediumname: '',
        PlayListItem_DateRestrictions: [],
        PlayListItem_DaytimeRestrictions: []
      },
      timestampForTree: new Date(),
      treeViewParams: {
        showThumbs: {
          value: false,
          icon: 'image',
          titleActivate: this.$t('show thumbs'),
          titleDeactivate: this.$t('hide thumbs')
        },
        showRestrictions: {
          value: false,
          icon: 'clock',
          titleActivate: this.$t('show restrictions'),
          titleDeactivate: this.$t('hide restrictions')
        },
        showOnlyPlaylists: {
          value: false,
          icon: 'film',
          titleActivate: this.$t('hide non-container media'),
          titleDeactivate: this.$t('show non-container media')
        },
        showIdentation: {
          value: false,
          icon: 'indent',
          titleActivate: this.$t('remove indentation'),
          titleDeactivate: this.$t('indent')
        },
        showOnlyPlayable: {
          value: false,
          icon: 'eye-slash',
          titleActivate: this.$t('hide media not fulfilling restrictions'),
          titleDeactivate: this.$t('show all media regardless of fulfilling restrictions')
        },
        menuBoardMode: {
          value: false,
          icon: 'address-card',
          titleActivate: this.$t('menuboard mode'),
          titleDeactivate: this.$t('disable menuboard mode')
        }
      }
    }
  },
  watch: {
    mediumId: async function (newVal, oldVal) {
      this.playListData = undefined
      this.newMediumId = this.mediumId
    },
    newMediumId: async function (newVal, oldVal) {
      if (newVal === oldVal) return
      await this.reloadData('newMediumId')
    },
    medium: async function (newVal, oldVal) {
      // console.log(newVal, oldVal)
    }
  },
  validations: {
    name: {
      required,
      minLength: minLength(4)
    }
  },
  methods: {
    toggleTreeViewParam (key) {
      this.treeViewParams[key].value = !this.treeViewParams[key].value
    },
    setPlaylistData (data) {
      this.playListData = data
    },
    closeRightClickMenu () {
      if (this.$refs.PlayListEditor) this.$refs.PlayListEditor.closeRightClickMenu()
      if (this.$refs.LayoutEditorSmall) this.$refs.LayoutEditorSmall.closeRightClickMenu()
    },
    showMediumBasicEditor () {
      this.mediumBasicEditorVisible = true
    },
    closeMediumBasicEditor () {
      this.mediumBasicEditorVisible = false
    },
    async showMediumTreeView () {
      this.playListTree.PlayItems = (await Vue.axios.post('medium/getPlaylistContentTree', { playListId: this.medium.id })).data
      this.playListTree.mediumname = this.medium.name
      this.playListTree.type = this.medium.type
      this.playListTree.PlayListItem_DateRestrictions = this.medium.PlayListItem_DateRestrictions
      this.playListTree.PlayListItem_DaytimeRestrictions = this.medium.PlayListItem_DaytimeRestrictions
      if (this.medium.type === 'PlayListDesktop') {
        this.playListTree.mediumname = this.getMediumName(this.mediumInStore)
        const timeRestrictions = (await Vue.axios.post('deviceDesktop/getTimeRestrictions', { desktopId: this.medium.DeviceDesktop })).data
        this.playListTree.PlayListItem_DateRestrictions = timeRestrictions.dateRestrictions
        this.playListTree.PlayListItem_DaytimeRestrictions = timeRestrictions.daytimeRestrictions
      }
      this.playListTreeVisible = true
    },
    closeMediumTreeView () {
      this.playListTreeVisible = false
    },
    async loadData () {
      this.componentVisible = undefined
      await this.$store.dispatch('Medium/getMedium', {
        data: this.newMediumId,
        options: { populate: true }
      })
      this.mediumInStore = this.$store.state.Medium.media_list.find(
        item => item.id === this.newMediumId
      )
      this.medium = this.mediumInStore
      let component
      if (!this.componentVisibleRequested) {
        if (this.medium.type.startsWith('PlayList')) {
          component = this.medium.type.startsWith('PlayListLayout') ? 'LayoutEditorSmall' : 'PlayListEditor'
        } else {
          component = 'MediumInPlaylists'
        }
      } else {
        component = this.componentVisibleRequested
      }
      this.componentVisible = component
    },
    async refreshPlayListLayout () {
      await this.loadData('refreshPlayListLayout')
    },
    async refreshPlaylist () {
      if (this.componentVisible === 'LayoutEditorSmall') {
        this.refreshPlayListLayout()
      }
      // Avoid full reload if playlistEditor is active
      if (this.componentVisible === 'PlayListEditor') {
        if (this.$refs['PlayListEditor']) this.$refs['PlayListEditor'].reloadPlaylist()
      }
    },
    async reloadData (action = null) {
      if (action === 'replaceInPlaylist') {
        this.refreshPlaylist()
        return
      }
      try {
        this.loading = true
        this.medium = undefined
        this.mediumInStore = undefined
        this.replaceLastPathItem = false
        this.selectedPlayitemId = this.PlayItemId
        try {
          await Vue.axios.get(`medium/${this.newMediumId}`, { disableResponseInterceptors: true })
        } catch (error) {
          console.log('Currently open medium was deleted')
          return
        }
        await this.loadData()
        this.$store.dispatch('Medium/addMediumIdToMediaEditHistory', this.mediumInStore)
        this.$store.dispatch('Medium/clearMediaSelectedRight')
        this.$store.dispatch('Medium/addSelectedRight', [ this.mediumInStore ])
      } catch (error) {
        this.loading = false
      } finally {
        this.loading = false
      }
    },
    deselectPlayitems ($event) {
      if ($event.ctrlKey || $event.metaKey) return
      this.$store.commit('Medium/SET_PLAYITEMS_SELECTED_RIGHT', [])
      if (this.$refs.PlayListEditor) this.$refs.PlayListEditor.closeRightClickMenu()
      if (this.$refs.LayoutEditorSmall) this.$refs.LayoutEditorSmall.closeRightClickMenu()
    },
    selectAll () {
      if (this.$refs.PlayListEditor) this.$refs.PlayListEditor.selectAll()
      if (this.$refs.LayoutEditorSmall) this.$refs.LayoutEditorSmall.selectAll()
    },
    showPlayItemsOptions ($event) {
      if (this.optionsDisabled) return
      const item = this.$store.state.Medium.playitems_selected_right[this.$store.state.Medium.playitems_selected_right.length - 1]
      if (this.$refs.PlayListEditor) this.$refs.PlayListEditor.openRightClickMenu(item, $event)
      if (this.$refs.LayoutEditorSmall) this.$refs.LayoutEditorSmall.openRightClickMenu(item, $event)
    },

    loadMediumFromHistory (medium) {
      this.$store.dispatch('Medium/clearBreadcrumbs')
      this.$emit('loadEditMediumInMediaEditor', medium)
      this.$store.dispatch('Medium/addMediumIdToBreadcrumbs', medium.id)
    },
    loadEditMediumInMediaEditor (medium) {
      this.$emit('loadEditMediumInMediaEditor', medium)
    },
    loadMediumUsageInMediaEditor (medium) {
      this.$emit('loadMediumUsageInMediaEditor', medium)
    },
    loadPathInLibrary (path) {
      this.$emit('loadPathInLibrary', path)
    },
    reloadLeftComponent () {
      this.$emit('reloadLeftComponent')
    },
    async showComponent (component) {
      this.componentVisible = component
      this.componentVisibleRequested = component
    },
    async submit () {
      await this.$store.dispatch('Medium/saveMediumToServer', {
        data: this.medium,
        columns: ['name']
      })
      this.$emit('close-EditMedium')
    },
    canMediumDelete () {
      if (this.medium.type.indexOf('PlayList') === -1) {
        return true
      }
      if (this.medium.type === 'PlayListDesktop') return false
      if (this.medium.PlayListItems.length === 0) return true
      return false
    },
    getMediumName (medium) {
      if (!medium) return
      if (medium.type !== 'PlayListDesktop') {
        return medium.name
      }
      return `${this.$t('Local Playlist of ')}${this.fullNameOfDesktopPlaylist(medium)}`
    }
  },
  computed: {
    optionsDisabled () {
      return (this.componentVisible !== 'PlayListEditor' || this.$store.state.Medium.playitems_selected_right.length < 1)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.menu-button  {
  padding: 10px;
  font-size: 20px;
  color: $--color-text-primary;
  &:hover {
    color: $--color-primary;
  }
  &.active {
    color: $--color-warning;
  }
  &.disabled {
    color: $--color-text-placeholder;
    cursor: not-allowed;
  }
  &.separator {
    border-left: 0px solid rgba($--color-text-placeholder, 0.3);
  }
}
.header-title-underlined {
  display: flex;
  height: 39px;
  border: 0px dotted green;
  align-items: center;
  .thumbnail {
    border: 0px dotted blue;
    background-size:contain;
    background-position: center center;
    background-repeat: no-repeat;
    height: 44px;
    width: 72px;
  }
  .medium-header-text {
    border: 0px dotted blue;
    display: flex;
    flex-direction: column;
    margin-left: 20px;
    // max-width: 100%;
    // height: 39px;
    // overflow: hidden;
    font-size: $--font-size-base;
    // color: $--color-warning;
    .text-line {
      line-height: 19px;
      &.first-line {
        color: $--color-warning;
        font-size: $--font-size-big;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 650px;
      }
      &.second-line {
        color: $--color-text-secondary;
      }
    }
  }
  .media-editor-menu {
    margin-left: auto;
  }
  .edit-history-button {
    margin-left: 30px;
  }
}
.medium-still-exists-name {
  cursor: pointer;
  color: $--color-text-secondary;
}
.header-row-playlist-tree {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/MediumEditor.vue